import { LOCAL_THREAD_ID_PREFIX, NEW_CHAT_THREAD_ID } from '@/common/constants';
import { safeLocalStorage, safeSessionStorage } from '@/lib/storage/safe-storage';

import { createIdMapper } from './id-mapper';

const FORCE_RESTORE_FLAG = 'force-thread-restore';
const PENDING_LOCAL_THREAD_KEY = 'pending-local-thread-id';
const threadIdMapper = createIdMapper();

export function isNewChat(threadId?: string | null): boolean {
  return (
    !threadId ||
    threadId === NEW_CHAT_THREAD_ID ||
    threadId === '' ||
    threadId.startsWith(LOCAL_THREAD_ID_PREFIX)
  );
}

export function isLocalThreadId(threadId?: string | null): boolean {
  return !!threadId && threadId.startsWith(LOCAL_THREAD_ID_PREFIX);
}

export function isThreadReady(
  threadItems: readonly { id: string; remoteId?: string }[],
  threadId: string,
): boolean {
  return threadItems.some(item => item.id === threadId || item.remoteId === threadId);
}

export function findThread<T extends { id: string; remoteId?: string }>(
  threadItems: readonly T[],
  threadId: string,
): T | undefined {
  return threadItems.find(item => item.id === threadId || item.remoteId === threadId);
}

export function setForceThreadRestore(): void {
  safeLocalStorage.setItem(FORCE_RESTORE_FLAG, 'true');
}

export function getForceThreadRestore(): boolean {
  return safeLocalStorage.getItem(FORCE_RESTORE_FLAG) === 'true';
}

export function clearForceThreadRestore(): void {
  safeLocalStorage.removeItem(FORCE_RESTORE_FLAG);
}

export function getOrCreateThreadUuid(localThreadId: string): string {
  return threadIdMapper.getOrCreate(localThreadId);
}

export function getThreadUuid(threadId: string): string {
  if (isLocalThreadId(threadId)) {
    return threadIdMapper.getOrCreate(threadId);
  }
  return threadId;
}

export function setPendingLocalThreadId(threadId: string): void {
  safeSessionStorage.setItem(PENDING_LOCAL_THREAD_KEY, threadId);
}

export function getPendingLocalThreadId(): string | null {
  return safeSessionStorage.getItem(PENDING_LOCAL_THREAD_KEY);
}

export function clearPendingLocalThreadId(): void {
  safeSessionStorage.removeItem(PENDING_LOCAL_THREAD_KEY);
}
